<template>
    <article class="ifr__warnings">
        <WarningsIntro/>
        <section 
        v-for="(question, index) in questions"
        :data-route="$t(question.name)"
        :class="['ifr__warning ifr__warning--question ifr__warning--question-'+ question.id, { 'ifr__warning--question-reverse' : question.orientation == 'rtl', 'ifr__warning--question-creme' : question.color == 'creme' }]">
            <div class="-ui-container">
                <div :class="['-ui-grid']">
                    <div class="-ui-col-50 ifr__warning-content">
                        <header>
                            <h4 v-html="$t(question.subject)"></h4>
                            <span class="warning__index">{{ question.id }} {{ $t('warnings.general.of' ) }} {{ questions.length }}</span>
                        </header>
                        <h3 v-html="$t(question.question)"></h3>
                        <footer :class="[{'is--hided': question.answer != null }]">
                            <ul>
                                <li>
                                    <button :class="['ifr__question-btn ifr__question-btn--yes', {'is--active': question.answer == 1} ]" @click="scoreYes(question, index)">
                                        <span>{{ $t('warnings.general.yes' ) }}</span>
                                        <span>{{ $t('warnings.general.yes' ) }}</span>
                                    </button>
                                </li>
                                <li>
                                    <button :class="['ifr__question-btn ifr__question-btn--no', {'is--active': question.answer == 0} ]" @click="scoreNo(question, index)">
                                        <span>{{ $t('warnings.general.no' ) }}</span>
                                        <span>{{ $t('warnings.general.no' ) }}</span>
                                    </button>
                                </li>
                            </ul>
                        </footer>
                        <div :class="['ifr__warning-message', { 'is--active': question.answer != null }]">
                            <p>{{ $t(question.message) }}</p> 
                            <button class="ifr__question-btn" @click="moveToNext(question, index)">
                                <span>{{ $t('warnings.general.next') }}</span>
                                <span>{{ $t('warnings.general.next') }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="-ui-col-50 ifr__warning-pic">
                        <div class="img__wrap">
                            <img :src="question.image">   
                            <div
                                v-for="(tooltip, index) in question.tooltips"
                                :class="['ifr__question-tooltip ifr__question-tooltip-'+index]"
                                >
                                    <span class="ifr__question-tooltip-icon"></span>
                                    <span class="ifr__question-tooltip-txt">{{ $t(tooltip) }}</span>
                                </div> 
                                <ul class="ifr__warnings-ssmm">
                                    <li class="ifr__warnings-ssmm--fb">
                                        <a :href='"https://www.facebook.com/sharer/sharer.php?u=https://www.paho.org/hablemos-sobre-demencia/signos-de-advertencia/&quote="+$t(question.question)' target="_blank">
                                            <svg width="50px" height="90px" viewBox="0 0 50 90" >
                                                <path d="M50,15.6465 L35.717,15.6465 C34.029,15.6465 32.143,17.8675 32.143,20.8385 L32.143,31.1535 L50,31.1535 L50,45.8535 L32.143,45.8535 L32.143,90.0005 L15.285,90.0005 L15.285,45.8535 L0,45.8535 L0,31.1535 L15.285,31.1535 L15.285,22.5005 C15.285,10.0925 23.896,0.0005 35.717,0.0005 L50,0.0005 L50,15.6465 Z" id="Fill-1"></path>
                                            </svg>
                                        </a>
                                    </li>
                                    <li class="ifr__warnings-ssmm--tw">
                                        <a :href='"https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.paho.org%2Fhablemos-sobre-demencia%2Fsignos-de-advertencia%2F&via=opsoms&hashtags=hablemos%2Cdemencia&text="+$t(question.question)' target="_blank">
                                            <svg width="92px" height="15px" viewBox="0 0 92 75">
                                                <path d="M92,8.8497 C88.613,10.3517 84.977,11.3657 81.158,11.8227 C85.057,9.4867 88.049,5.7867 89.459,1.3797 C85.811,3.5417 81.771,5.1137 77.473,5.9597 C74.029,2.2907 69.123,-0.0003 63.695,-0.0003 C53.271,-0.0003 44.82,8.4507 44.82,18.8737 C44.82,20.3537 44.986,21.7937 45.309,23.1747 C29.623,22.3887 15.711,14.8737 6.404,3.4537 C4.779,6.2427 3.848,9.4847 3.848,12.9437 C3.848,19.4917 7.18,25.2677 12.244,28.6537 C9.152,28.5557 6.24,27.7077 3.695,26.2937 C3.693,26.3717 3.693,26.4507 3.693,26.5307 C3.693,35.6757 10.201,43.3047 18.834,45.0377 C17.252,45.4697 15.584,45.7017 13.861,45.7017 C12.646,45.7017 11.465,45.5827 10.311,45.3627 C12.713,52.8607 19.686,58.3187 27.943,58.4697 C21.482,63.5337 13.346,66.5507 4.502,66.5507 C2.979,66.5507 1.477,66.4607 0,66.2847 C8.352,71.6417 18.271,74.7677 28.934,74.7677 C63.65,74.7677 82.637,46.0047 82.637,21.0617 C82.637,20.2457 82.619,19.4307 82.582,18.6197 C86.27,15.9597 89.469,12.6357 92,8.8497" id="Fill-1"></path>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>             
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <WarningsScore/>
    </article>
</template>

<script>
import WarningsIntro from '@/components/WarningsIntro'
import WarningsScore from '@/components/WarningsScore'
import fullpage from 'fullpage.js'
export default {
    name: 'warnings',
    components: { 
        WarningsIntro,
        WarningsScore
    },
    computed: {
        questions() {
            return this.$store.state.warnings
        },
        score() {
            return this.$store.state.score
        },
        answers() {
            return this.$store.state.answers
        }
    },
    methods: {
        fullpage() {
            let THIS = this
            new fullpage('.ifr__warnings', {
                licenseKey: '0AF857E1-EE824B45-9758CCE4-DF3C0C5E',
                sectionSelector: '.ifr__warning',
                controlArrows: false,
                afterRender: function(){
                    fullpage_api.setAllowScrolling(false)
                    fullpage_api.setKeyboardScrolling(false)
                },
                afterLoad (origin, destination, direction) {
                    if (destination.isFirst) {
                        if (!destination.item.classList.contains('ifr__timelined')) {
                            var h1 = destination.item.querySelector('h1'),
                            h2 = destination.item.querySelector('h2'),
                            h3 = destination.item.querySelector('h3'),
                            p = destination.item.querySelector('p'),
                            btn = destination.item.querySelector('button'),
                            pic = destination.item.querySelector('.img__wrap'),
                            introTl = new TimelineMax()
                            introTl
                            .add('h3Tl')
                            .fromTo(h3, .3, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 'h3Tl' )
                            .add('h1Tl')
                            .fromTo(h1, .3, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 'h1Tl' )
                            .add('h2Tl')
                            .fromTo(h2, .3, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 'h2Tl' )
                            .add('pTl')
                            .fromTo(p, .3, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 'pTl' )
                            .add('btnTl')
                            .fromTo(btn, .3, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 'btnTl' )
                            .add('picTl')
                            .fromTo(pic, 1, { opacity: 0, x: 1000 }, { opacity: 1, x: 0 }, 'picTl' )
                            // Prevent animation twice
                            destination.item.classList.add('ifr__timelined')
                            // Set scroll to
                            //fullpage_api.moveTo(2)
                           
                        } 
                    } else if (destination.isLast) {
                        // Animation
                        if (!destination.item.classList.contains('ifr__timelined')) {
                            var score = destination.item.querySelector('ifr__warnings-score-total'),
                            all = destination.item.querySelector('.ifr__question-btn--all'),
                            replay = destination.item.querySelector('.ifr__question-btn--replay'),
                            warning = destination.item.querySelector('p.is--active'),
                            scoreTl = new TimelineMax()
                            scoreTl
                            .add('warningTl')
                            .fromTo(warning, .3, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 'warningTl' )
                            .add('ctasTl')
                            .fromTo(all, .3, { opacity: 0, x: -50 }, { opacity: 1, x: 0 }, 'ctasTl' )
                            .fromTo(replay, .3, { opacity: 0, x: 50 }, { opacity: 1, x: 0 }, 'ctasTl' )
                             // Prevent animation twice
                            destination.item.classList.add('ifr__timelined')
                        }
                    } else {
                        // Animation
                        if (!destination.item.classList.contains('ifr__timelined')) {
                            var pic = destination.item.querySelector('.img__wrap'),
                            route = destination.item.getAttribute('data-route'),
                            header = destination.item.querySelector('header'),
                            question = destination.item.querySelector('h3'),
                            yes = destination.item.querySelector('.ifr__question-btn--yes'),
                            no = destination.item.querySelector('.ifr__question-btn--no'),
                            tooltips = destination.item.querySelectorAll('.ifr__question-tooltip'),
                            fb = destination.item.querySelector('.ifr__warnings-ssmm--fb'),
                            tw = destination.item.querySelector('.ifr__warnings-ssmm--tw'),
                            questionTl = new TimelineMax()
                            questionTl
                            .add('picTl')
                            .fromTo(pic, .5, { opacity: 0 }, { opacity: 1 }, 'picTl' )
                            .add('headerTl')
                            .fromTo(header, .3, { opacity: 0, y: -100 }, { opacity: 1, y: 0 }, 'headerTl' )
                            .add('questionTl')
                            .fromTo(question, .5, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 'questionTl' )
                            .add('answerTl')
                            .fromTo(yes, .3, { opacity: 0, x: -50 }, { opacity: 1, x: 0 }, 'answerTl' )
                            .fromTo(no, .3, { opacity: 0, x: 50 }, { opacity: 1, x: 0 }, 'answerTl' )
                            //.add('tooltipsTl')
                            //.staggerFromTo(tooltips, .2, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, .1, 'tooltipsTl' )
                            .add('ssmmTl')
                            .fromTo(fb, .3, { opacity: 0, x: -50 }, { opacity: 1, x: 0 }, 'ssmmTl' )
                            .fromTo(tw, .3, { opacity: 0, x: 50 }, { opacity: 1, x: 0 }, 'ssmmTl' )
                            
                            // Prevent animation twice
                            destination.item.classList.add('ifr__timelined')
                            //console.log(destination)
                            //THIS.$router.push({ path: route })
                        }
                    }
                }
            })
        },
        scoreYes(question, index) {
            this.$store.commit('scoreYes', {question, index})
        },
        scoreNo(question, index) {
            this.$store.commit('scoreNo', {question, index})
        },
        moveToNext(question, index) {
            fullpage_api.moveTo(index + 3)
        }
    },
    mounted() {
        if (window.innerWidth > 1024) {
            this.fullpage()
        } 
        var THIS = this
        window.onresize = function() {
            if (document.querySelector('html').classList.contains('fp-enabled')){
                if (window.innerWidth <= 1024) {
                    fullpage_api.destroy()
                }
            } else {
                if (window.innerWidth > 1024) {
                    THIS.fullpage()
                }
            }
        }
    }
}
</script>
